import PropTypes from 'prop-types';
import Image from 'next/image';
import breakPoints from 'helpers/Styles';
import Link from 'next/link';
import { useState, useEffect, useContext } from 'react';
import SoldOutLabel from 'components/SoldOutLabel/index-rts';
import cn from 'classnames';
import ProductPerformanceTips from '../../containers/Product/ProductToolTip/ProductTips';
import Progress_bar from 'components/LineBar/progressBar';
import { kFeatureList } from 'utils/constants';
import LimitedTimeDealTimer from 'components/CountdownTimers/LimitedTimeDealTimer';
import RestockTimer from 'components/CountdownTimers/RestockTimer';
import { useQuery } from '@apollo/client';
import {
  PRODUCT_BY_HANDLE,
  productByHandleVars,
} from 'helpers/graphql/product';
import useScreenWidth from 'utils/useScreenWidth';
import { StorefrontContext } from 'providers/storefront';
import { renderPngIcon, sortedFeatures } from 'helpers/specifications';
import SubHeader from 'components/SubHeader';

const ProductCardRTS = ({ item, buttonLabel, fixedPrice, type }) => {
  const { setIsLaptop } = useContext(StorefrontContext);
  const [showTitle, setShowTitle] = useState(false);
  if (!item.product) return '';
  const productTags = item?.product?.tags.split(',');

  const [tooltip, setTooltip] = useState(-1);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const performanceTags = productTags?.filter((tag) =>
    tag.trim().startsWith('performance:'),
  );
  const specificationTags = productTags.filter((item) =>
    item.trim().startsWith('specifications:'),
  );
  const sameDayShipping = productTags.filter((item) =>
    item.trim().startsWith('shipping:'),
  );
  const category = productTags.filter((item) =>
    item.trim().startsWith('category:'),
  );

  const uniqueSpecs = productTags.filter((item) =>
    item.trim().startsWith('unique:'),
  );

  const isUniquelist = productTags.find((item) =>
    item.trim().startsWith('list_type:'),
  );

  const categoryList = category.length > 0 && category[0]?.split(':');
  categoryList.shift();
  const checkCategoryLaptop = categoryList.includes('LAPTOPS');

  const sameDayShipAvab =
    sameDayShipping.length > 0 && sameDayShipping[0].split(':')[1];

  const calledBanner = productTags.filter((item) =>
    item.trim().startsWith('banner:'),
  );

  let checkEndDate = 0;
  let checkEndDateReStock = 0;
  let isLimited = false;
  let isRestocking = false;

  let startDate = null;
  let endDate = null;
  let restockDate = null;

  const widthSize = useScreenWidth();

  const { loading, data, error } = useQuery(PRODUCT_BY_HANDLE, {
    variables: productByHandleVars(item?.product?.handle),
  });
  if (!error) {
    if (data != undefined) {
      const timerTags = data?.product?.tags?.filter((item) =>
        item.trim().startsWith('timer:'),
      );

      if (timerTags?.length > 0) {
        timerTags.forEach((timerTag) => {
          switch (timerTag.trim().split(':')[1]) {
            case 'limit':
              isLimited = true;
              break;
            case 'restock':
              isRestocking = true;
              break;
            default:
              isLimited = false;
              isRestocking = false;
          }
        });
        const now = new Date().getTime();
        if (isLimited) {
          endDate = data?.product?.metafields?.edges.find(
            (item) =>
              item?.node?.namespace === 'custom' &&
              item?.node?.key === 'limited_time_deal_end',
          )?.node?.value;
          startDate = data?.product?.metafields?.edges.find(
            (item) =>
              item?.node?.namespace === 'custom' &&
              item?.node?.key === 'limited_time_deal_start',
          )?.node?.value;
          const countDownEndDate = new Date(endDate).getTime();
          checkEndDate = countDownEndDate - now;
        }
        if (isRestocking) {
          restockDate = data?.product?.metafields?.edges.find(
            (item) =>
              item?.node?.namespace === 'custom' &&
              item?.node?.key === 'restock_time',
          )?.node?.value;
          const countDownRestockDate = new Date(restockDate).getTime();
          checkEndDateReStock = countDownRestockDate - now;
          console.log({ checkEndDateReStock, item, isRestocking, restockDate });
        }
      }
    }
  }

  const calledBannerText =
    calledBanner.length > 0 && calledBanner[0].split(':')[1];

  const preparedSpecifications = sortedFeatures(specificationTags).filter(
    (spec) => {
      if (spec.type.toLowerCase() === 'cpu') return spec;
      if (spec.type.toLowerCase() === 'graphics-card') return spec;
      if (spec.type.toLowerCase() === 'ram') return spec;
      if (spec.type.toLowerCase() === 'storage') return spec;
      if (spec.type.toLowerCase() === 'display') return spec;
      if (spec.type.toLowerCase() === 'motherboard') return spec;
      if (spec.type.toLowerCase() === 'cooler') return spec;
    },
  );

  const handleOpenModal = (idx) => {
    setIsTooltipOpen(true);
    setTooltip(idx);
  };

  const [imageUrl, setImageUrl] = useState(
    item?.product?.images[0]?.src ||
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/product.png?v=1714032274',
  );
  const handleHoverOn = () => {
    if (item?.product?.images[1]?.src) {
      setImageUrl(item.product.images[1].src);
    }
  };
  const handleHoverLeave = () => {
    setImageUrl(item?.product?.images[0]?.src || 'item.product.images[0]?.src');
  };

  useEffect(() => {
    if (typeof item.product.images[0]?.src !== 'undefined')
      setImageUrl(item?.product?.images[0]?.src);
  }, [item]);

  const handleCloseModal = () => {
    setIsTooltipOpen(false);
  };

  const getShippingTag = (tag) => {
    switch (tag) {
      case 'same-day-shipping':
        return 'Same Day Shipping';
      case 'next-day-shipping':
        return 'Next Day Shipping';
      case 'pre-order':
        return 'Pre Order';
      default:
        return '';
    }
  };

  useEffect(() => {
    const productHandle = sessionStorage.getItem('productHandle');
    if (productHandle != null) {
      const offsetTop = document.getElementsByClassName(
        `desktop${productHandle}`,
      )[0].offsetTop;
      window.scrollTo({ top: offsetTop - 130, behavior: 'instant' });
    }
  }, []);

  useEffect(() => {
    item.product.tags.includes('category:LAPTOPS')
      ? setIsLaptop(true)
      : setIsLaptop(false);
  });

  const parsedSpecifications = specificationTags
    .map((spec) => {
      const parts = spec.split(':');
      const key = parts[2];
      const value = parts.slice(3).join(':');

      return { [key]: value };
    })
    .reduce((acc, curr) => ({ ...acc, ...curr }), {});

  return (
    <div className={type + item.product.handle}>
      <div className='product_card'>
        <div className='product_card_contents'>
          <div
            className='product_title'
            style={
              calledBanner != '' ||
              (item.product.variants?.[0]?.inventory_policy !== 'continue' &&
                item.product.variants?.[0]?.inventory_quantity < 1)
                ? { paddingTop: 16 }
                : { paddingTop: 10 }
            }
          >
            <Link href={`/products/${item.product.handle}` || '#'}>
              <a
                href={`/products/${item.product.handle}` || '#'}
                className='view_more'
              >
                {item.product.title.split('/')[0]}
              </a>
            </Link>
          </div>
          <div className='product_keywords'>
            {/* {item.product.title.split('/')[1]} */}
            <SubHeader tags={parsedSpecifications} title={item.product.title} />
          </div>

          <div className={cn('image-container')}>
            <div
              className={cn('image-container')}
              style={
                widthSize <= 990 &&
                item.product.variants?.[0]?.inventory_policy !== 'continue' &&
                item.product.variants?.[0]?.inventory_quantity < 1
                  ? { opacity: 0.4 }
                  : {}
              }
            >
              {widthSize <= 990 && (
                <div className='image-background'>
                  <div className='bg-image-container darken-image'>
                    <Image
                      draggable={false}
                      src={imageUrl}
                      width={300}
                      height={300}
                      alt='background_image'
                    />
                    <div className='overlay'></div>
                  </div>
                </div>
              )}
            </div>
            {item?.product?.images[1]?.src ? (
              <Link href={`/products/${item.product.handle}` || '#'}>
                <a
                  href={`/products/${item.product.handle}` || '#'}
                  className='view_more'
                >
                  <div
                    className={
                      item.product.variants?.[0]?.inventory_policy !==
                        'continue' &&
                      item.product.variants?.[0]?.inventory_quantity < 1
                        ? 'image-sold-out'
                        : ''
                    }
                  >
                    <Image
                      draggable={false}
                      src={imageUrl}
                      alt={item.product.title}
                      width={widthSize <= 990 ? 280 : 312}
                      height={widthSize <= 990 ? 280 : 312}
                      onMouseEnter={handleHoverOn}
                      onMouseLeave={handleHoverLeave}
                    />
                  </div>
                </a>
              </Link>
            ) : (
              <Link href={`/products/${item.product.handle}` || '#'}>
                <a
                  href={`/products/${item.product.handle}` || '#'}
                  className='view_more'
                >
                  <div
                    className={
                      item.product.variants?.[0]?.inventory_policy !==
                        'continue' &&
                      item.product.variants?.[0]?.inventory_quantity < 1
                        ? 'image-sold-out'
                        : ''
                    }
                  >
                    <Image
                      draggable={false}
                      src={imageUrl}
                      alt={item.product.title}
                      width={widthSize <= 990 ? 280 : 312}
                      height={widthSize <= 990 ? 280 : 312}
                    />
                  </div>
                </a>
              </Link>
            )}
          </div>

          {performanceTags?.length > 0 && (
            <>
              <div className='product_benchmarks'>
                {performanceTags.map((tag, idx) => {
                  const title =
                    typeof tag?.split(':')[1] !== 'undefined'
                      ? tag?.split(':')[1].replace('-', ' ').toUpperCase()
                      : '';
                  const percentage =
                    typeof tag?.split(':')[2] !== 'undefined'
                      ? tag.split(':')[2]
                      : '';
                  // console.log('percentage', percentage);
                  return (
                    <>
                      <div className=' collectionPage stat' key={tag}>
                        <div className='stat-label'>
                          <div className='performance-title'>
                            <div>{title}</div>
                          </div>
                          <div className='performance-tips'>
                            <div
                              className='tip_icon'
                              onClick={() => handleOpenModal(idx)}
                            >
                              <Image
                                draggable={false}
                                src='https://cdn.shopify.com/s/files/1/0637/0407/2436/files/info_1.png?v=1714033735'
                                alt='performance tip'
                                width={15}
                                height={15}
                              />
                            </div>
                          </div>

                          {tooltip === idx && (
                            <ProductPerformanceTips
                              name={title}
                              page={'collection'}
                              isTooltipOpen={isTooltipOpen}
                              handleCloseModal={handleCloseModal}
                            />
                          )}
                        </div>
                        <Progress_bar
                          bgcolor='#7ed321'
                          progress={percentage || 0}
                        />
                      </div>
                    </>
                  );
                })}
              </div>
              <hr className='card-breakline' />
            </>
          )}

          {preparedSpecifications?.length > 0 && (
            <div className='product_features'>
              <div className='product_features_item'>
                {isUniquelist
                  ? uniqueSpecs?.map((item, idx) => {
                      const featureType = item.trim().split(':')[2];
                      const featureText = item.trim().split(':')[3];
                      const res = kFeatureList.find(
                        (feature) => feature.groupType === featureType,
                      );
                      return (
                        <div className='feature_item' key={idx}>
                          <Image
                            draggable={false}
                            src={res.image}
                            alt={res.groupType}
                            width={22}
                            height={22}
                          />
                          <div className='feature_title'>{featureText}</div>
                        </div>
                      );
                    })
                  : preparedSpecifications.map((item, tag) => {
                      const { type, description } = item;
                      const iconStyle =
                        widthSize <= 990
                          ? type === 'Storage'
                            ? { padding: '0 1px' }
                            : {}
                          : type === 'Storage'
                          ? { padding: '0 3px' }
                          : {};
                      return (
                        <div className='feature_item' key={tag}>
                          {type && (
                            <div
                              onMouseLeave={() => setShowTitle(false)}
                              onMouseEnter={() => setShowTitle(tag)}
                              style={iconStyle}
                            >
                              {showTitle === tag ? (
                                <span className='feature_item_title' style={{}}>
                                  {type}
                                </span>
                              ) : null}
                              <Image
                                draggable={false}
                                src={renderPngIcon(type)}
                                alt='product_features'
                                width={
                                  widthSize <= 990
                                    ? type === 'Storage'
                                      ? 12
                                      : 17
                                    : type === 'Storage'
                                    ? 17
                                    : 22
                                }
                                height={widthSize <= 990 ? 17 : 22}
                              />
                            </div>
                          )}
                          <div className='feature_title'>{description}</div>
                        </div>
                      );
                    })}
                {sameDayShipAvab && sameDayShipAvab != 'delayed' && (
                  <div className='feature_item shipping-tag-con'>
                    {getShippingTag(sameDayShipAvab) !== '' && (
                      <div>
                        <Image
                          draggable={false}
                          src={
                            getShippingTag(sameDayShipAvab) != 'Pre Order'
                              ? 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/truck-green.png?v=1714056888'
                              : 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/truck-cyan.png?v=1714056921'
                          }
                          alt='product_features'
                          width={widthSize <= 990 ? 15 : 22}
                          height={widthSize <= 990 ? 15 : 22}
                        />
                      </div>
                    )}
                    <div className='feature_title shipping-tag'>
                      <span
                        className={
                          getShippingTag(sameDayShipAvab) != 'Pre Order'
                            ? 'glow'
                            : 'glow2'
                        }
                      >
                        {getShippingTag(sameDayShipAvab)}
                      </span>
                    </div>
                  </div>
                )}
                {checkEndDate > 0 && (
                  <LimitedTimeDealTimer
                    startDate={startDate}
                    endDate={endDate}
                    timerLabel={'Deals ends in'}
                  />
                )}
                {checkEndDateReStock > 0 && (
                  <RestockTimer
                    restockDate={restockDate}
                    timerLabel={'Limited Stock To Be Reloaded In'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <div className='product_pricing'>
          <div className='product_pricing_total'>
            <span className='product_pricing_from'>
              {fixedPrice ? 'SGD' : 'from SGD'}
            </span>
            {item?.product?.variants[0]?.price && (
              <span className='product_pricing_price'>
                <span>&#36;</span>
                {parseFloat(item.product.variants[0].price).toLocaleString()}
              </span>
            )}
            {item?.product?.variants[0]?.compare_at_price && (
              <span className='product_pricing_compare_price'>
                <strike>
                  {parseFloat(
                    item.product.variants[0].compare_at_price,
                  ).toLocaleString()}
                </strike>
              </span>
            )}
          </div>
        </div>
        <div className='product_link'>
          <Link href={`/products/${item.product.handle}`}>
            <a href={`/products/${item.product.handle}`} className='view_more'>
              {buttonLabel || 'START CUSTOMISING'}
            </a>
          </Link>
        </div>
        <div className='banner-container'>
          {item.product.variants?.[0]?.inventory_policy !== 'continue' &&
          item.product.variants?.[0]?.inventory_quantity < 1 ? (
            <SoldOutLabel />
          ) : (
            ''
          )}
          {/* {item.product.variants?.[0]?.inventory_policy !== "continue" &&
          item.product.variants?.[0]?.inventory_quantity < 1 ? (
            <SoldOutLabel />
          ) : (
            sameDayShipAvab &&
            sameDayShipAvab !== false &&
            typeof sameDayShipAvab !== "false" && (
              <div
                className={`same_day_shipping ${
                  sameDayShipAvab === "delayed" &&
                  sameDayShipping.length === 1
                    ? "hide"
                    : ""
                }`}
              >
                <img draggable="false" 
                  src="/images/truck.png"
                  alt="first_level menu"
                  layout="fixed"
                  width={15}
                  height={15}
                />
                {sameDayShipAvab === "same-day-shipping" && (
                  <button>SAME DAY SHIPPING</button>
                )}
                {sameDayShipAvab === "next-day-shipping" && (
                  <button>NEXT DAY SHIPPING</button>
                )}
                {sameDayShipAvab === "pre-order" && (
                  <button>PRE ORDER</button>
                )}
              </div>
            )
          )} */}
          {calledBanner != '' && (
            <div className='same_day_shipping'>
              <button>{calledBannerText}</button>
            </div>
          )}
        </div>
      </div>
      <style jsx>
        {`
          .product_title {
            height: 2.75rem;
          }
          .product_keywords {
            height: 1rem;
          }
          #imagecontainer {
            height: 310px;
          }
          .same_day_shipping {
            top: 0;
            right: 0;
            font-family: 'Roboto-Medium';
            text-transform: uppercase;
            font-size: 10px;
            line-height: 16px;
            padding: 1px 4px;
            background-color: #646464;
            border-radius: 2px;
            color: #e4e4e4;
            -webkit-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            left: 0;
            padding: 2px 4px 2px 4px;
            background: #950810;
            border-radius: 2px;
            text-align: center;
            width: 45%;
          }
          .same_day_shipping img {
            width: 12px;
            height: auto;
            margin-top: 5px;
          }
          .same_day_shipping button {
            background: transparent;
            border: none;
            font-weight: 600;
            font-size: 10px;
            line-height: 16px;
            text-align: center;
            color: #e4e4e4;
            padding: 0;
          }
          @media (max-width: ${breakPoints.medium}) {
            .same_day_shipping {
              top: 32px;
            }
            .product_features {
              display: inline-block !important;
              height: auto !important;
              padding-top: 0;
              padding-bottom: 10px;
            }
          }
          .tip_icon {
            cursor: pointer;
          }
          .stat + .stat {
            margin-top: 20px;
          }
          .performance-tips {
            float: right;
          }
          .look_feel_title .performance-tips {
            margin-left: 5px;
          }
          .performance-tags {
            padding-top: 10px;
          }
          .stat-label {
            display: flex;
            position: relative;
            font-size: 12px;
            line-height: normal;
            color: #949494;
            align-items: center;
          }
          .performance-title {
            margin-bottom: 4px;
            color: #949494;
            font-family: 'Roboto-Medium';
            font-size: 13px;
            letter-spacing: 0;
            line-height: 20px;
            margin-right: 10px;
            display: flex;
            gap: 4px;
          }
          .Storage {
            padding: 3px 7px 0 2px;
          }
          .benchmark_text img {
            filter: invert(0.4);
            width: 17px;
            height: auto;
            position: relative;
            top: 4px;
            left: 5px;
          }
          .image-container {
            position: inherit !important;
          }
          .product_card {
            width: 308px;
            flex: 1;
            position: relative;
          }
          .product_card_contents {
            background: #242424;
            color: #e4e4e4;
            width: 312px;
            border-radius: 4px 4px 0 0;
          }
          .product_title {
            color: #e4e4e4;
            font-family: 'big_noodle_titling';
            font-size: 25px;
            letter-spacing: 0;
            line-height: 32px;
            text-align: center;
          }
          .product_keywords {
            color: #949494;
            font-family: 'Roboto-Medium';
            font-size: 14px;
            -webkit-letter-spacing: 0;
            -moz-letter-spacing: 0;
            -ms-letter-spacing: 0;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
            margin-bottom: 10px;
            min-height: 24px;
          }
          .product_benchmarks {
            // display: flex;
            color: #949494;
            font-size: 13px;
            letter-spacing: 0;
            padding: 15px;
            -webkit-letter-spacing: 0;
            -moz-letter-spacing: 0;
            -ms-letter-spacing: 0;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
          }
          .benchmark_percentage {
            width: 50px;
            // height: 50px;
            margin-top: 5px;
          }

          .benchmark_category {
            width: 50%;
            display: initial;
            align-items: center;
          }
          .benchmark_text {
            padding-top: 25px;
            padding-left: 5px;
          }
          hr {
            width: 90%;
            border: none;
            height: 1px;
            background-color: #949494;
          }
          .product_features {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 20px;
            padding: 15px;
            height: 400px;
          }
          .product_features_item {
            width: 98%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 0 auto;
            gap: 10px 15px;
          }
          .feature_item_title {
            border: 1px solid #3b3b3b;
            padding: 4px;
            position: absolute;
            top: -30px;
            left: -15px;
            text-align: center;
            background: #242424;
          }
          .feature_item {
            width: 100%;
            display: flex;
            gap: 10px;
            align-items: start;
            color: #e4e4e4;
            font-family: 'Roboto-Normal';
            font-size: 13px;
            letter-spacing: 0;
            line-height: 20px;
            position: relative;
          }
          .feature_title {
            text-align: left;
            width: 90%;
            overflow: hidden;
            height: auto;
            line-height: normal;
            text-overflow: ellipsis;
            // white-space: nowrap;
          }
          .feature_icon {
            margin-top: 0px;
            width: 10%;
          }
          .product_pricing {
            display: flex;
            flex-direction: column;
            background-color: #141414;
            padding: 30px;
            align-items: center;
            justify-content: center;
            width: 312px;
          }
          .product_pricing_total {
            display: flex;
            gap: 10px;
            align-items: center;
            justify-content: center;
          }
          .product_pricing_from {
            color: #949494;
            font-family: 'Roboto-Normal';
            font-size: 13px;
            letter-spacing: 0;
            line-height: 13px;
            text-align: right;
          }
          .product_pricing_price {
            color: #e4e4e4;
            font-family: 'big_noodle_titling';
            font-size: 31px;
            letter-spacing: 0;
            line-height: 40px;
          }
          .product_pricing_compare_price {
            color: #949494;
            font-family: 'Roboto-Normal';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 13px;
            text-align: right;
          }
          .product_link {
            background-color: #950810;
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 50px;
            height: 50px;
            text-align: center;
            width: 312px;
            border-radius: 0 0 4px 4px;
          }
          .product_link:hover {
            background-color: #800006;
          }
          .view_more {
            display: block;
            width: 100%;
            height: 100%;
          }
          hr {
            background-color: #343434 !important;
          }
          .image-container {
            position: relative;
          }
          .image-sold-out {
            opacity: 0.4;
          }
          .hide {
            display: none;
          }
          @media (max-width: ${breakPoints.medium}) {
            .product_card {
              margin: 0 auto;
              padding: 32px 0;
            }
          }
          .banner-container {
            width: 100%;
            display: flex;
            /* justify-content: center; */
            /* align-items: center; */
            position: absolute;
            top: 0;
            justify-content: space-evenly;
            flex-direction: inherit;
          }
          .shipping-tag-con {
            justify-content: center;
            margin-left: -7%;
            height: 18px;
          }
          .shipping-tag {
            color: #00e300;
            display: flex;
            align-items: center;
            font-weight: bold;
            font-family: 'Roboto-Medium';
            width: auto;
            height: auto;
          }
          .bg-image {
            /* The image used */
            background-image: url('photographer.jpg');

            /* Add the blur effect */
            filter: blur(5px);
            -webkit-filter: blur(8px);

            /* Full height */
            height: 100%;

            /* Center and scale the image nicely */
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          }
          .image-background {
            background-color: black;
            width: 102%;
            height: 280px;
            position: absolute;
            overflow: hidden;
          }
          .bg-image-container {
            width: 100%;
            height: 280px;
            position: absolute;
            filter: blur(2px);
            top: -51px;
          }
          .bg-image-container .image {
            width: 100%;
            height: 100%;
            position: relative !important;
            object-fit: cover; // Optional
          }
          .darken-image .overlay {
            position: absolute;
            top: 49px;
            left: 0;
            width: 100%;
            height: 110%;
            background-color: rgb(0 0 0 / 60%); /* black with 50% opacity */
          }
          @media (max-width: ${breakPoints.medium}) {
            .same_day_shipping {
              top: 32px;
            }
            .banner-container {
              top: 32px;
            }
            .product_features {
              display: inline-block !important;
              height: auto !important;
              padding-top: 5px;
              padding-bottom: 5px;
            }
            .shipping-tag-con {
              justify-content: center;
              margin-left: -2%;
              height: 18px;
            }
            .product_pricing {
              padding: 0px;
            }
            .product_pricing_price {
              font-size: 18px;
            }
            .product_title {
              line-height: 15px;
              font-size: 18px;
            }
            .product_keywords {
              font-size: 12px;
              margin-bottom: 0px;
              text-transform: uppercase;
            }
            .product_features_item {
              gap: 5px 15px;
            }
            .card-breakline {
              display: none;
            }
            .feature_item {
              font-size: 11px;
            }
            .view_more {
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .product_link {
              font-size: 12px;
              height: 35px;
            }
            .glow {
              font-size: 12px;
            }
            .glow2 {
              font-size: 12px;
            }
            .product_pricing_from {
              font-size: 10px;
            }
            .product_pricing_compare_price {
              font-size: 10px;
            }
            .image-sold-out {
              opacity: 1;
            }
            .same_day_shipping button {
              font-size: 8px;
            }
          }
        `}
      </style>
    </div>
  );
};

ProductCardRTS.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object.isRequired,
  buttonLabel: PropTypes.string,
  fixedPrice: PropTypes.bool,
};

ProductCardRTS.defaultProps = {
  buttonLabel: 'START CUSTOMISING',
  fixedPrice: false,
};

export default ProductCardRTS;
